 
const NETWORKS = {
  //mainet not to be touched except a contract is changed
  
  10: {
    BASIC_GREEN_PROJECT: "0x0fCa51616a975bcD557ba1A86E708f7562e8bb6D",
    BASIC_INFRASTRUCTURE_CHANGE: "0x8Bd3Ef1B1C2BfA82B384c4A0B28342af6872EDc6",
    GOVERNANCE_GREEN_PROJECT: "0xeeEB6faede309C4aB989f67F7c77815E1298d9A8",
    GOVERNANCE_INFRASTRUCTURE_CHANGE: "0xc4220E90aB6144B08209A8f0e37E0504B25ff315",
    GOVERNANCE_CARBON_MONITORING: "0xF7f008A1e5A827C326fA6284c97c59c3Fe660B06",
    GREEN_PROJECT_NFT: "0xb63B6e7Bd1ED0BD9885d6F6B5EFA969bCcf154a2",
    INFRASTRUCTURE_CHANGE_NFT: "0x5cD2f2DA60B3E278472595d98e82013aFCB221F3",
    CLOSE_CARBON_TOKEN: "0x80A9e51F4e883Cf51aDc203911d9C0F9BCf48f2F",
    DONATION_CERTIFICATE: "0xaA1D0B0029D8a4169ef42514E6B8c3B93578fDaf"
  },

//testnet

  11155420: {
    BASIC_INFRASTRUCTURE_CHANGE: "0x7a4630aCF154d9B0e423d62Bee513E78B96C8A7d",
    ENERGY_TRADING_ADDRESS: "0xfD72f341843455D51564282D95966C619B6b2780",
    ENERGY_TRADING_CONTRACT_ADDRESS: "0xb763ecF4323B5ce42c5D6a39Cc0E11c712fE104b",
    BUSINESS_GREEN: "0x56E366d3b2861D96C1B41286680EE7a4fbe41740",
    // CLOSE_CARBON_ENERGY_EFFICIENCY: "0xd61E6E1c98B84d4D9F598F503a152bA928FC19fc",
    CLOSE_CARBON_ENERGY_EFFICIENCY: "0x81a4b87792A413Ea20B94d8031e2dccFFF2c40ba",
    BUSINESS_INFRASTRUCTURE_CHANGE: "0x684978580A1314Ec2f13Fe2e6459374D79e907DB",
    BUSINESS_CARBON_MONITORING: "0xb03a2bEe64aA51421521a0259cA2e4ccB056bcb8",




  },
  80001: {
    CARBON_MONITORING: "",
  },
  1: {
    /* Mainnet addresses */ CARBON_MONITORING: "",
  },
};
 
export { NETWORKS };
 
// 0xcB08c7549Fe7b429a4133ed46Cb2b738D05815e9
 